import { ElementMatcher } from './common/ElementMatcher';
export class Toggle {
    constructor(win = window) {
        this.win = win;
        this.doc = this.win.document;
        this.lastHash = '#';
    }
    activate() {
        this.onHashChanged();
        this.win.addEventListener('hashchange', () => this.onHashChanged(), false);
        this.doc.addEventListener('click', (event) => {
            ElementMatcher.emittedByOrChild(event, '[data-toggle]', (element) => {
                this.toggle(element);
            });
        });
    }
    onHashChanged() {
        const hash = this.win.location.hash;
        if (this.lastHash === hash) {
            return;
        }
        if (this.lastHash && this.lastHash !== '#') {
            this.toggleTargetClasses(`[data-toggle-on-hash='${this.lastHash.substr(1)}']`);
        }
        if (hash && hash !== '#') {
            this.toggleTargetClasses(`[data-toggle-on-hash='${hash.substr(1)}']`);
        }
        this.lastHash = hash;
    }
    toggle(elem) {
        this.toggleSelfClass(elem);
        const toggleQuery = elem.dataset.toggle;
        if (toggleQuery != null) {
            this.toggleTargetClassesAndHashes(toggleQuery);
        }
    }
    toggleSelfClass(elem) {
        const toggleClass = elem.dataset.toggleClass;
        if (toggleClass) {
            elem.classList.toggle(toggleClass);
        }
    }
    toggleTargetClassesAndHashes(toggleQuery) {
        const targets = this.queryHtmlElements(toggleQuery);
        targets
            .filter(elem => !!elem.dataset.toggleOnHash)
            .forEach(elem => this.toggleHash(elem));
        targets
            .filter(elem => !elem.dataset.toggleOnHash)
            .forEach(elem => this.toggleClass(elem));
    }
    toggleTargetClasses(toggleQuery) {
        this.queryHtmlElements(toggleQuery)
            .forEach(elem => this.toggleClass(elem));
    }
    queryHtmlElements(selector) {
        const nodes = this.doc.querySelectorAll(selector);
        return Array.from(nodes)
            .filter(elem => elem instanceof HTMLElement)
            .map(elem => elem);
    }
    toggleClass(elem) {
        this.setupToggleClass(elem);
        const toggleClass = elem.dataset.toggleClass;
        if (toggleClass) {
            elem.classList.toggle(toggleClass);
        }
    }
    toggleHash(elem) {
        const loc = this.win.location;
        const toggleOnHash = '#' + elem.dataset.toggleOnHash;
        if (toggleOnHash !== '#') {
            if (loc.hash === toggleOnHash) {
                this.win.history.pushState('', document.title, loc.pathname + loc.search);
            }
            else {
                this.win.history.pushState('', document.title, loc.pathname + loc.search + toggleOnHash);
            }
            window.dispatchEvent(new HashChangeEvent('hashchange'));
        }
    }
    setupToggleClass(elem) {
        if (!elem.dataset.toggleClass) {
            if (elem.classList.contains('show')) {
                elem.dataset.toggleClass = 'show';
            }
            else {
                elem.dataset.toggleClass = 'hide';
            }
        }
    }
}
